import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer
      className="relative pt-24 pb-10 border-t border-[var(--line)] bg-[var(--bg)]"
      data-testid="site-footer"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <Reveal>
              <div className="font-mono-tech text-[11px] text-[var(--ink-2)] mb-6">
                Ateliê Acervo 3D · Brasil
              </div>
              <p className="font-serif-display text-3xl md:text-4xl leading-[1.05] tracking-tight max-w-[22ch]">
                <em className="italic">Itens que contam histórias</em> — feitos
                com carinho, criatividade e propósito.
              </p>
            </Reveal>
          </div>

          <div className="col-span-6 md:col-span-2 md:col-start-8">
            <div className="font-mono-tech text-[10px] text-[var(--ink-3)] mb-6">
              Navegação
            </div>
            <ul className="space-y-3 font-mono-tech text-[11px]">
              {[
                ["#origem", "01 · História"],
                ["#processo", "02 · Processo"],
                ["#acervo", "03 · Acervo"],
                ["#encomendas", "04 · Encomendas"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="text-[var(--ink)] link-under"
                    data-testid={`footer-nav-${h.replace("#", "")}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-tech text-[10px] text-[var(--ink-3)] mb-6">
              Contato
            </div>
            <ul className="space-y-3 font-mono-tech text-[11px]">
              <li>
                <a
                  href="https://www.instagram.com/acervo_3d/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[var(--ink)] link-under"
                  data-testid="footer-instagram"
                >
                  Instagram · @acervo_3d
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5511942681399"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[var(--ink)] link-under"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@acervo3d.com.br"
                  className="text-[var(--ink)] link-under"
                  data-testid="footer-email"
                >
                  contato@acervo3d.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="mt-24 md:mt-40">
          <div className="font-serif-display leading-[0.82] tracking-[-0.05em] text-[24vw] md:text-[19vw] text-[var(--ink)] select-none pointer-events-none">
            Acervo<span className="text-[var(--accent)]">.</span>3D
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[var(--line)] flex flex-col md:flex-row justify-between items-start md:items-center gap-4 font-mono-tech text-[10px] text-[var(--ink-3)]">
          <span>© MMXXVI Acervo 3D — Todos os direitos reservados</span>
          <div className="flex items-center gap-6">
            <span>Peças únicas</span>
            <span>·</span>
            <span>Feito com carinho</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
